export const DEFAULT_BOARD_MATCH = "session.role >= 'moderator' OR highlighted = true";
export const DEFAULT_AUDIO_MATCH = "session != null";
